import React from "react";
import { useNavigate } from "react-router-dom";
import { Zap, MailCheck } from "lucide-react";
import { brand, footer } from "../mock";

const Footer = () => {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const handleLink = (l) => {
    const key = l.toLowerCase();
    if (key === "admin") {
      navigate("/admin");
    } else if (key === "pricing" || key === "faq") {
      scrollTo(key);
    } else {
      scrollTo("home");
    }
  };
  return (
    <footer className="bg-[#070b14] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-lg bg-[#0f1a30] border border-yellow-400/30 flex items-center justify-center">
                <Zap className="w-6 h-6 text-yellow-400 fill-yellow-400" />
              </span>
              <div>
                <div className="font-pixel text-yellow-400 text-lg tracking-wider">{brand.name}</div>
                <div className="text-[10px] tracking-[0.3em] text-slate-400">{brand.subtitle}</div>
              </div>
            </div>
            <p className="text-slate-400 mt-5 max-w-md leading-relaxed">{footer.blurb}</p>
          </div>

          <div className="md:justify-self-end w-full md:max-w-sm">
            <div className="flex items-center gap-3 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-xl px-5 py-4">
              <MailCheck className="w-5 h-5 shrink-0" />
              <span className="text-sm font-medium">{footer.delivery}</span>
            </div>
            <div className="flex flex-wrap gap-6 mt-6 md:justify-end">
              {footer.links.map((l) => (
                <button
                  key={l}
                  onClick={() => handleLink(l)}
                  className="text-slate-300 hover:text-yellow-400 transition-colors"
                >
                  {l}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-6 flex flex-col gap-3">
          <p className="text-slate-500 text-sm">{footer.copyright}</p>
          <p className="text-slate-600 text-xs leading-relaxed">{footer.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
